// extracted by mini-css-extract-plugin
export default {"title_box":"index_title_box_grU-R clearfix","num":"index_num_rR-d6","bar":"index_bar_TTTB3","title":"index_title_-cedc","title_boxr":"index_title_boxr_Peb0O"};